import VueRouter from 'vue-router'
import di from 'di'

import AppTemplate from 'app/components/AppTemplate.vue'
import Login from 'app/components/routes/Login.vue'
import RenewPassword from 'app/components/routes/RenewPassword.vue'
import ForgotPassword from 'app/components/routes/ForgotPassword.vue'
import ResetPassword from 'app/components/routes/ResetPassword.vue'

import Users from 'app/components/routes/user/Users.vue'
import UserForm from 'app/components/routes/user/UserForm.vue'
import Projects from 'app/components/routes/project/Projects.vue'
import ProjectForm from 'app/components/routes/project/ProjectForm.vue'
import { default as AppError, Mode as ErrorMode } from '@wittignl/js-cms/components/views/Error.vue'

import Permission from 'app/enums/Permission'

export default class {

    run(){

        const acl = di.get('acl');

        const routes = [
            {
                name: 'login',
                path: '/login',
                component: Login,
                meta: {
                    authorized: false
                }
            },
            {
                name: 'renew-password',
                path: '/renew-password',
                component: RenewPassword,
                meta: {
                    authorized: false
                }
            },
            {
                name: 'forgot',
                path: '/forgot',
                component: ForgotPassword,
                meta: {
                    authorized: false
                }
            },
            {
                name: 'reset',
                path: '/reset',
                component: ResetPassword,
                meta: {
                    authorized: false
                }
            },
            {
                path: '/',
                component: AppTemplate,
                redirect(){

                    if(acl.can(Permission.ROUTE_USERS)){
                        return { name: 'users' };
                    }
                    else {

                        return { name: 'account' };
                    }
                },
                children: [
                    {
                        name: 'users',
                        path: 'users',
                        component: Users,
                        meta: {
                            access: Permission.ROUTE_USERS
                        }
                    },
                    {
                        name: 'user-add',
                        path: 'users/add',
                        component: UserForm,
                        meta: {
                            access: Permission.ROUTE_USERS
                        }
                    },
                    {
                        name: 'user-edit',
                        path: 'users/:id',
                        component: UserForm,
                        meta: {
                            access: Permission.ROUTE_USERS
                        }
                    },
                    {
                        name: 'account',
                        path: 'account',
                        component: UserForm,
                        meta: {
                            access: Permission.ROUTE_ACCOUNT
                        }
                    },
                    {
                        name: 'projects',
                        path: 'projects',
                        component: Projects,
                        meta: {
                            access: Permission.ROUTE_PROJECTS
                        }
                    },
                    {
                        name: 'project-add',
                        path: 'projects/add',
                        component: ProjectForm,
                        meta: {
                            access: Permission.ROUTE_PROJECTS
                        }
                    },
                    {
                        name: 'project-edit',
                        path: 'projects/edit/:id',
                        component: ProjectForm,
                        meta: {
                            access: Permission.ROUTE_PROJECTS
                        }
                    }
                ]
            },
            {
                name: 'forbidden',
                path: '/forbidden',
                props: { mode: ErrorMode.FORBIDDEN },
                component: AppError,
                meta: {
                    authorized: false
                }
            },
            {
                name: 'error',
                path: '/error',
                component: AppError,
                props: { mode: ErrorMode.NOT_FOUND },
                meta: {
                    authorized: false
                }
            },
            {
                path: '*',
                component: AppError,
                props: { mode: ErrorMode.NOT_FOUND },
                meta: {
                    authorized: false
                }
            }
        ];

        const router = new VueRouter({
            mode: 'history',
            linkActiveClass: 'active',
            // base: '/admin/',
            routes
        });

        // Auth hook
        router.beforeEach((to, from, next) => {

            if(to.meta.authorized === false){

                next();
                return;
            }

            let auth = di.get('auth');

            if(!auth.loggedIn()) {
                next({ name: 'login' });
            }
            else {
                next();
            }
        });

        // ACL hook
        router.beforeEach(acl.createRouteHook());

        di.set('router', router);
    }
}
